import { apiGate } from '../../services/api_gate'

export async function getAllLeads(dados){
    try {
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou do getAllLeads',dados) }
        const api = await apiGate.post('crm/corretor/leads', dados)
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('api', api.data)
        return api
    }
    catch (e) {
        return null
    }
}